<template>
  <main class="login-view">
    <div>
      <h1 class="text-center">
        Login
      </h1>

      <form @submit.prevent="handleSubmit">
        <BaseInput name="email" @input="handleInput" />
        <BaseInput name="password"
                   type="password"
                   @input="handleInput" />

        <button cy="submit-btn"
                :disabled="submitDisabled">
          Submit
        </button>
      </form>
    </div>
  </main>
</template>

<script setup>
  import BaseInput from "@/components/BaseInput.vue";

  import {useStore} from "vuex";
  import {computed, ref} from "vue";

  const { state, dispatch, commit } = useStore()
  const form = ref({email: '', password: ''})
  const submitDisabled = computed(() => {
    return Object.keys(form.value)
        .some(val => !form.value[val]) || state.auth.submitDisabled
  })

  function handleInput ({name, value}) {
    form.value[name] = value
  }

  function handleSubmit () {
    dispatch("login", form.value)
  }
</script>

<style lang="scss">
  @import "../styles/vars.scss";

  .login-view {
    @media only screen and (min-width: 0) {
      > div {
        max-width: 400px;
        margin: 0 auto;
        padding-top: 80px;
        h1 {
          opacity: 0.6;
        }
        form {
          .base-input {
            margin-bottom: 12px;
          }
          input {
            width: 100%;
          }
          button {
            width: 100%;
            margin-top: 16px;
            background-color: $green;
            color: white;
            font-weight: bold;
            font-size: 1.8rem;
          }
        }
      }
    }
  }
</style>